import { render, staticRenderFns } from "./video-thumb.vue?vue&type=template&id=a70611c0"
import script from "./video-thumb.vue?vue&type=script&lang=js"
export * from "./video-thumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports